/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerChatLazy_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChat_viewer">;
    readonly " $refType": "PdpRespDealerChatLazy_viewer";
};
export type PdpRespDealerChatLazy_viewer$data = PdpRespDealerChatLazy_viewer;
export type PdpRespDealerChatLazy_viewer$key = {
    readonly " $data"?: PdpRespDealerChatLazy_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChatLazy_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerChatLazy_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerChat_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '39299dcdbfcca8e391b9cb3bb4863e6e';
export default node;
